import type { ReactNode } from 'react';
import { Modal } from './Modal';

type Variante = 'peligro' | 'advertencia';

interface Props {
  icono: ReactNode;
  titulo: string;
  mensaje: ReactNode;
  detalle?: ReactNode;
  textoConfirmar: string;
  iconoBotonConfirmar?: ReactNode;
  variante: Variante;
  onConfirmar: () => void;
  onCancelar: () => void;
}

const variantes: Record<
  Variante,
  { fondoIcono: string; colorIcono: string; botonConfirmar: string }
> = {
  peligro: {
    fondoIcono: 'bg-red-100',
    colorIcono: 'text-red-600',
    botonConfirmar: 'bg-red-600 hover:bg-red-700',
  },
  advertencia: {
    fondoIcono: 'bg-orange-100',
    colorIcono: 'text-orange-600',
    botonConfirmar: 'bg-orange-500 hover:bg-orange-600',
  },
};

export function DialogoConfirmacion({
  icono,
  titulo,
  mensaje,
  detalle,
  textoConfirmar,
  iconoBotonConfirmar,
  variante,
  onConfirmar,
  onCancelar,
}: Props) {
  const estilos = variantes[variante];

  return (
    <Modal onClose={onCancelar}>
      <div className="flex items-center gap-3 mb-4">
        <div className={`${estilos.fondoIcono} p-3 rounded-full ${estilos.colorIcono}`}>
          {icono}
        </div>
        <h2 className="text-xl font-bold text-gray-800">{titulo}</h2>
      </div>
      <p className="text-gray-600 mb-4">{mensaje}</p>
      {detalle && <div className="mb-6">{detalle}</div>}
      <div className="flex gap-3">
        <button
          onClick={onConfirmar}
          className={`flex-1 ${estilos.botonConfirmar} text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center justify-center gap-2`}
        >
          {iconoBotonConfirmar}
          {textoConfirmar}
        </button>
        <button
          onClick={onCancelar}
          className="flex-1 px-6 py-3 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
        >
          Cancelar
        </button>
      </div>
    </Modal>
  );
}
